$(document).ready(function () {
  let $body = $("body");
  $body.on("click", ".open-sizeguide", function (e) {
    e.preventDefault();
    $(".size-guide-popup").css("display", "flex").hide().fadeIn();
  });
  $(".close-sizeguide").click(function () {
    $(".size-guide-popup").fadeOut();
  });
  $body.on("click", ".open-buynow", function (e) {
    e.preventDefault();
    $(".popup-buynow").fadeIn();
  });

  $body.on("click", ".close-buynow", function (e) {
    e.preventDefault();
    $(".popup-buynow").fadeOut();
  });

  $body.on("click", ".tab-title", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });

  $body.on("click", ".related-products p", function (e) {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });

  $(document).mouseup(function (e) {
    var sizeguide = $(".size-guide-content");
    if (!sizeguide.is(e.target) && sizeguide.has(e.target).length === 0) {
      $(".size-guide-popup").fadeOut();
    }
    var buynow = $(".popup-buynow");
    if (!buynow.is(e.target) && buynow.has(e.target).length === 0) {
      $(".popup-buynow").fadeOut();
    }
  });

  function currentSize() {
    console.log(111111);
    
    const size = $(".product__selectors input:checked").val();
    $(".current-size").html(size);
    if ($(`[data-size="${size}"]`)) {
      $(".content-size").hide();
      $(`[data-size="${size}"]`).show();
    } else {
      $(".content-size").hide();
    }
  }

  currentSize();

  if ($body.hasClass("template-product") || $body.hasClass("template-index")) {
    currentSize();
    $body.on("change", ".product-form-vue .swatch-Size input", function () {
      currentSize();
    });
    $body.on(
      "change",
      ".product-complete__form .swatch-Size input",
      function () {
        if ($(this).parent().hasClass("soldout")) {
          $(this)
            .parents(".shopify-product-form")
            .find("#AddToCart")
            .addClass("disabled");
        } else {
          $(this)
            .parents(".shopify-product-form")
            .find("#AddToCart")
            .removeClass("disabled");
          let value = $(this).val(),
            $select = $(this)
              .parents(".shopify-product-form")
              .find(".form-control"),
            $option = $(this)
              .parents(".shopify-product-form")
              .find(".form-control option"),
            valueSelected = 0;
          $option.each(function () {
            if ($(this).attr("data-value") === value) {
              valueSelected = $(this).val();
            }
          });
          $select.val(valueSelected).change();
        }
      }
    );

    $body.on("click", ".product-complete__form #AddToCart", function (e) {
      if ($(this).hasClass("disabled")) {
        e.preventDefault();
        let handle = $(this).data("handle");
        $(`#bis-${handle}`).addClass("active");
      }
    });
    $body.on("click", ".action-close", function (e) {
      $(".klaviyo-bis").removeClass("active");
    });

    $(document).on("submit", ".form-bis-jq", function (e) {
      e.preventDefault();
      let data = $(this).serializeArray();
      let variant = data.find((item) => item.name === "variantId").value;
      let email = data.find((item) => item.name === "email").value;
      const klaviyoPublicKey = window.klaviyoPublicKey;
      const url =
        "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe";
      const params = new URLSearchParams();
      params.append("a", klaviyoPublicKey);
      params.append("email", email);
      params.append("variant", variant);
      params.append("platform", "shopify");
      const config = {
        method: "POST",
        redirect: "follow",
        body: params,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      };
      fetch(url, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            $(".completed_message").show();
          }
        });
    });
  }
  $(window).on("load", function () {
    setTimeout(function () {
      const productsComplete = new Swiper(".products-complete-list", {
        slidesPerView: 1,
        grid: {
          rows: 1,
        },
        pagination: {
          el: ".products-complete-list .swiper-pagination",
          clickable: true,
        },
      });
      const productsSections = new Swiper(
        ".featured-collection__container.swiper-container",
        {
          slidesPerView: 1,
          grid: {
            rows: 1,
          },
          navigation: {
            nextEl:
              ".featured-collection__container.swiper-container .swiper-button-next",
            prevEl:
              ".featured-collection__container.swiper-container .swiper-button-prev",
          },
          paginationClickable: true,
          loop: true,
        }
      );

      const productRecommendations = new Swiper(
        ".product-recommendations__slideshow",
        {
          slidesPerView: 2,
          loop: false,
          cache: false,
          pagination: {
            el: ".product-recommendations__slideshow .swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".product-recommendations__slideshow .swiper-button-next",
            prevEl: ".product-recommendations__slideshow .swiper-button-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
            },
          },
        }
      );

      const covetPics = new Swiper(".covet-pics-wrap-acf", {
        slidesPerView: 2,
        loop: false,
        cache: false,
        pagination: {
          el: ".covet-pics-wrap-acf .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".covet-pics-wrap-acf .swiper-button-next",
          prevEl: ".covet-pics-wrap-acf .swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 5,
          },
        },
      });
    }, 400);
  });
  $(".acf-data").click(function () {
    let dataContent = $(this).find(".data-content").html(),
      dataUrl = $(this).find(".data-content").attr("data-url"),
      image = $(this).find(".data-image").attr("src");
    $(".popup-acf__image img").attr("src", image);
    $(".popup-acf__description").html(dataContent);
    $(".popup-acf__link").attr("href", dataUrl);
    $(".popup-acf").css("display", "flex").hide().fadeIn();
  });
  $(".acf-close,.popup-acf__bg").click(function () {
    $(".popup-acf").fadeOut();
  });
  $(document).on("submit", ".products-complete #AddToCartForm", function (e) {
    e.preventDefault();
    console.log(1);
    function addToCartOk(product) {
      console.log("success");
      $("body").trigger("ajaxProduct");
    }

    function addToCartFail(obj, status) {
      console.log("fail");
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: $(this).serialize(),
      success: addToCartOk,
      error: addToCartFail,
    });
  });

  // $body.on(
  //   "change",
  //   ".product-complete__form .product-linked_swatch .color_linked",
  //   function () {
  //     console.log(33333);
  //     e.preventDefault();
  //     // console.log(1223, $(this).parents('.shopify-product-form').find('input[name:product-id]'));
  //   }
  // );

  $(".product-complete__form .product-linked_swatch .color_linked").click(
    function (e) {
      // e.preventDefault();
      console.log(
        1223,
        $(this).parents(".shopify-product-form").find("input[name=product-id]")
      );
      $(this)
        .parents(".shopify-product-form")
        .find("input[name=product-id]")
        .attr("value", $(this).attr("value"));
    }
  );

  $(document).on(
    "submit",
    ".product-grid-item__info #AddToCartForm",
    function (e) {
      e.preventDefault();
      console.log(2);
      function addToCartOk(product) {
        console.log("success");
        $("body").trigger("ajaxProduct");
      }

      function addToCartFail(obj, status) {
        console.log("fail");
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).serialize(),
        success: addToCartOk,
        error: addToCartFail,
      });
    }
  );
  $(document).on("click", "#us-atc", function (e) {
    e.preventDefault();
    const $form = $(this).parents("#AddToCartForm");
    const variant = $form.find("input:checked").val();
    console.log(variant);
    function addToCartOk(product) {
      console.log("success");
      $("body").trigger("ajaxProduct");
    }

    function addToCartFail(obj, status) {
      console.log("fail");
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: `quantity=1&id=${variant}`,
      success: addToCartOk,
      error: addToCartFail,
    });
  });

  $(document).on("click", ".product_grid_hover .swatch-element", function (e) {
    e.preventDefault();
    const disabled = $(this).attr("disabled");
    if (disabled) return;
    const $form = $(this).parents("#quickAddToCart");
    const variant = $(this).attr("data-value");

    $option = $(this)
      .parents(".product-grid-item")
      .find(".form-control option");
    let valueSelected = 0;
    $option.each(function () {
      if ($(this).attr("data-value") === variant) {
        valueSelected = $(this).val();
      }
    });

    let formData = $form.serialize();
    const params = new URLSearchParams(formData);
    params.set("id", valueSelected);
    params.set("option-1", variant);
    formData = params.toString();

    function addToCartOk(product) {
      console.log("success");
      $("body").trigger("ajaxProduct");
    }

    function addToCartFail(obj, status) {
      console.log("fail");
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: formData,
      success: addToCartOk,
      error: addToCartFail,
    });
  });
});


// Tick a box on cart
(function () {
  $(document).ready(function () {
    var showCheckoutBox = function() {
      if(document.getElementById('checkout-eu-uk')) {
        var checkout_eu_uk_input = document.getElementById('checkout-eu-uk');
        var checkout_eu_uk = document.getElementById('pre-checkout-eu-uk');
        fetch('https://freeipapi.com/api/json')
        .then(function(response) {
          response.json().then(jsonData => {
            console.log("jsonData",jsonData)
            let continentCode = jsonData.continentCode;
            let countryCode = jsonData.countryCode;
            if(continentCode == "EU" || countryCode == "GB") {
              checkout_eu_uk.classList.remove('hide');
              var cart_checkout = document.querySelector('button.cart__checkout[name="checkout"]');
              cart_checkout.disabled = true;
              checkout_eu_uk_input.addEventListener('change', function() {
                if(this.checked) cart_checkout.disabled = false;
                else cart_checkout.disabled = true;
              });
            }
          });
        })
        .catch(function(error) {
          console.log(error)
        });
      }
    }
    showCheckoutBox();
    document.addEventListener('theme:cart:loaded', function() {
      showCheckoutBox();
    })
  })
})();